import React from 'react';
import {useIntl} from "react-intl";
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import DetailsPanel from '../DetailsPanel';
import {InvoiceOrderDetails} from '../../types';
import icon from '../../../../common/assets/icons/eye.svg';
import styles from './ButtonDetails.module.scss';

export type ButtonDetailsProps = {
  row: InvoiceOrderDetails
}

const ButtonDetails = ({row}: ButtonDetailsProps) => {
  const intl = useIntl();
  const tooltip = intl.formatMessage({
    id: 'invoiceOrders-tooltip-details',
    defaultMessage: 'Order details'
  });

  const {setPopupPanelContent, openPopupPanel} = useGlobalContext();

  const handleClick = async () => {
    await setPopupPanelContent(<DetailsPanel {...row} />);
    await openPopupPanel();
  };

  return (
    <ButtonAction
      variant={'icon'}
      icon={icon}
      onClick={handleClick}
      customClassnames={{container: styles.buttonContainer}}
      title={tooltip}
    />
  );
};

export default ButtonDetails;
